import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}

export const Button: React.FC<ButtonProps> = ({ 
  variant = 'primary', 
  fullWidth = false,
  children,
  className = '',
  ...props 
}) => {
  const baseStyles = 'px-6 py-3 rounded-lg font-medium transition-colors disabled:opacity-50';
  const variantStyles = {
    primary: 'bg-primary text-white hover:bg-indigo-900',
    secondary: 'bg-secondary text-primary hover:bg-purple-300',
    outline: 'border-2 border-primary text-primary hover:bg-primary hover:text-white'
  };
  const widthStyles = fullWidth ? 'w-full' : '';

  return (
    <button
      className={`${baseStyles} ${variantStyles[variant]} ${widthStyles} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};